import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateForestStats = (state: StatsSnapshot) => {
  const forest = state.generators.forest;

  const generatedOutposts = forest.owned * forest.baseGeneration;

  stats.forest = {
    buildingsGeneration: generatedOutposts,
  };
};
